<template>
  <div class="ion-margin-top report-component">
    <!-- START Number item -->
    <ion-item>
      <ion-label v-if="placeholders && placeholders[0]" position="floating">
        {{ placeholders[0] }}
      </ion-label>
      <ion-label v-else position="floating">Saisir...</ion-label>

      <ion-select
        ok-text="Valider"
        :value="value ? value.toString() : ''"
        cancel-text="Annuler"
        :disabled="disabled"
        @ionChange="$emit('update:value', $event.detail.value)"
      >
        <template v-if="Array.isArray(options)">
          <ion-select-option
            v-for="option in options"
            :value="option"
            :key="option"
          >
            {{ option }}
          </ion-select-option>
        </template>

        <template v-else>
          <ion-select-option
            v-for="(label, value) in options"
            :value="value"
            :key="value"
          >
            {{ label }}
          </ion-select-option>
        </template>
      </ion-select>
    </ion-item>
  </div>
</template>

<script>
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/vue';

export default {
  name: 'Select',

  components: {
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
  },

  props: {
    title: String,
    placeholders: Array,
    value: String,
    disabled: Boolean,
    options: [Array, Object], // either an array of strings or an object with key-value pairs
  },

  emits: ['update:value'],
};
</script>
